/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthConfirmEmailRouteImport } from './routes/_auth/confirm-email'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppPremiumRouteRouteImport } from './routes/_app/premium/route'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin/settings/index'
import { Route as AdminFeatureRequestsIndexRouteImport } from './routes/admin/feature-requests/index'
import { Route as AdminCoursesIndexRouteImport } from './routes/admin/courses/index'
import { Route as AppPremiumIndexRouteImport } from './routes/_app/premium/index'
import { Route as AppMarketingKitIndexRouteImport } from './routes/_app/marketing-kit/index'
import { Route as AppFeedbackIndexRouteImport } from './routes/_app/feedback/index'
import { Route as AppDashboardIndexRouteImport } from './routes/_app/dashboard/index'
import { Route as AppCreateIndexRouteImport } from './routes/_app/create/index'
import { Route as AppCoursesIndexRouteImport } from './routes/_app/courses/index'
import { Route as AppChatIndexRouteImport } from './routes/_app/chat/index'
import { Route as AppAvatarsIndexRouteImport } from './routes/_app/avatars/index'
import { Route as AppSettingsSubscriptionRouteImport } from './routes/_app/settings/subscription'
import { Route as AppSettingsAccountSettingsRouteImport } from './routes/_app/settings/account-settings'
import { Route as AppPremiumPlansRouteImport } from './routes/_app/premium/plans'
import { Route as AppAvatarsCreateRouteImport } from './routes/_app/avatars/create'
import { Route as AdminCoursesCourseIdIndexRouteImport } from './routes/admin/courses/$courseId/index'
import { Route as AppCreateLinkedinIndexRouteImport } from './routes/_app/create/linkedin/index'
import { Route as AppCreateEbookIndexRouteImport } from './routes/_app/create/ebook/index'
import { Route as AppCoursesCourseIdIndexRouteImport } from './routes/_app/courses/$courseId/index'
import { Route as AdminCoursesCourseIdViewLessonsRouteImport } from './routes/admin/courses/$courseId/view-lessons'
import { Route as AdminCoursesCourseIdViewInfoRouteImport } from './routes/admin/courses/$courseId/view-info'
import { Route as AdminCoursesCourseIdViewAvatarsRouteImport } from './routes/admin/courses/$courseId/view-avatars'
import { Route as AdminCoursesCourseIdSeeAnalyticsRouteImport } from './routes/admin/courses/$courseId/see-analytics'
import { Route as AdminCoursesCourseIdManageAccessRouteImport } from './routes/admin/courses/$courseId/manage-access'
import { Route as AppCreateLinkedinFlowRouteImport } from './routes/_app/create/linkedin/flow'
import { Route as AppCreateEbookFlowRouteImport } from './routes/_app/create/ebook/flow'
import { Route as AppCoursesCourseIdSeeAnalyticsRouteImport } from './routes/_app/courses/$courseId/see-analytics'
import { Route as AppCoursesCourseIdManageAccessRouteImport } from './routes/_app/courses/$courseId/manage-access'
import { Route as AppCoursesCourseIdEditLessonsRouteImport } from './routes/_app/courses/$courseId/edit-lessons'
import { Route as AppCoursesCourseIdEditInfoRouteImport } from './routes/_app/courses/$courseId/edit-info'
import { Route as AppCoursesCourseIdEditAvatarsRouteImport } from './routes/_app/courses/$courseId/edit-avatars'

const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthConfirmEmailRoute = AuthConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPremiumRouteRoute = AppPremiumRouteRouteImport.update({
  id: '/premium',
  path: '/premium',
  getParentRoute: () => AppRouteRoute,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFeatureRequestsIndexRoute =
  AdminFeatureRequestsIndexRouteImport.update({
    id: '/feature-requests/',
    path: '/feature-requests/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCoursesIndexRoute = AdminCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppPremiumIndexRoute = AppPremiumIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPremiumRouteRoute,
} as any)
const AppMarketingKitIndexRoute = AppMarketingKitIndexRouteImport.update({
  id: '/marketing-kit/',
  path: '/marketing-kit/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFeedbackIndexRoute = AppFeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCreateIndexRoute = AppCreateIndexRouteImport.update({
  id: '/create/',
  path: '/create/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCoursesIndexRoute = AppCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppChatIndexRoute = AppChatIndexRouteImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAvatarsIndexRoute = AppAvatarsIndexRouteImport.update({
  id: '/avatars/',
  path: '/avatars/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsSubscriptionRoute = AppSettingsSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAccountSettingsRoute =
  AppSettingsAccountSettingsRouteImport.update({
    id: '/account-settings',
    path: '/account-settings',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppPremiumPlansRoute = AppPremiumPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AppPremiumRouteRoute,
} as any)
const AppAvatarsCreateRoute = AppAvatarsCreateRouteImport.update({
  id: '/avatars/create',
  path: '/avatars/create',
  getParentRoute: () => AppRouteRoute,
} as any)
const AdminCoursesCourseIdIndexRoute =
  AdminCoursesCourseIdIndexRouteImport.update({
    id: '/courses/$courseId/',
    path: '/courses/$courseId/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AppCreateLinkedinIndexRoute = AppCreateLinkedinIndexRouteImport.update({
  id: '/create/linkedin/',
  path: '/create/linkedin/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCreateEbookIndexRoute = AppCreateEbookIndexRouteImport.update({
  id: '/create/ebook/',
  path: '/create/ebook/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCoursesCourseIdIndexRoute = AppCoursesCourseIdIndexRouteImport.update({
  id: '/courses/$courseId/',
  path: '/courses/$courseId/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AdminCoursesCourseIdViewLessonsRoute =
  AdminCoursesCourseIdViewLessonsRouteImport.update({
    id: '/courses/$courseId/view-lessons',
    path: '/courses/$courseId/view-lessons',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCoursesCourseIdViewInfoRoute =
  AdminCoursesCourseIdViewInfoRouteImport.update({
    id: '/courses/$courseId/view-info',
    path: '/courses/$courseId/view-info',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCoursesCourseIdViewAvatarsRoute =
  AdminCoursesCourseIdViewAvatarsRouteImport.update({
    id: '/courses/$courseId/view-avatars',
    path: '/courses/$courseId/view-avatars',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCoursesCourseIdSeeAnalyticsRoute =
  AdminCoursesCourseIdSeeAnalyticsRouteImport.update({
    id: '/courses/$courseId/see-analytics',
    path: '/courses/$courseId/see-analytics',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminCoursesCourseIdManageAccessRoute =
  AdminCoursesCourseIdManageAccessRouteImport.update({
    id: '/courses/$courseId/manage-access',
    path: '/courses/$courseId/manage-access',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AppCreateLinkedinFlowRoute = AppCreateLinkedinFlowRouteImport.update({
  id: '/create/linkedin/flow',
  path: '/create/linkedin/flow',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCreateEbookFlowRoute = AppCreateEbookFlowRouteImport.update({
  id: '/create/ebook/flow',
  path: '/create/ebook/flow',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCoursesCourseIdSeeAnalyticsRoute =
  AppCoursesCourseIdSeeAnalyticsRouteImport.update({
    id: '/courses/$courseId/see-analytics',
    path: '/courses/$courseId/see-analytics',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCoursesCourseIdManageAccessRoute =
  AppCoursesCourseIdManageAccessRouteImport.update({
    id: '/courses/$courseId/manage-access',
    path: '/courses/$courseId/manage-access',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCoursesCourseIdEditLessonsRoute =
  AppCoursesCourseIdEditLessonsRouteImport.update({
    id: '/courses/$courseId/edit-lessons',
    path: '/courses/$courseId/edit-lessons',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCoursesCourseIdEditInfoRoute =
  AppCoursesCourseIdEditInfoRouteImport.update({
    id: '/courses/$courseId/edit-info',
    path: '/courses/$courseId/edit-info',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCoursesCourseIdEditAvatarsRoute =
  AppCoursesCourseIdEditAvatarsRouteImport.update({
    id: '/courses/$courseId/edit-avatars',
    path: '/courses/$courseId/edit-avatars',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/premium': typeof AppPremiumRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/confirm-email': typeof AuthConfirmEmailRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/avatars/create': typeof AppAvatarsCreateRoute
  '/premium/plans': typeof AppPremiumPlansRoute
  '/settings/account-settings': typeof AppSettingsAccountSettingsRoute
  '/settings/subscription': typeof AppSettingsSubscriptionRoute
  '/avatars': typeof AppAvatarsIndexRoute
  '/chat': typeof AppChatIndexRoute
  '/courses': typeof AppCoursesIndexRoute
  '/create': typeof AppCreateIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/feedback': typeof AppFeedbackIndexRoute
  '/marketing-kit': typeof AppMarketingKitIndexRoute
  '/premium/': typeof AppPremiumIndexRoute
  '/admin/courses': typeof AdminCoursesIndexRoute
  '/admin/feature-requests': typeof AdminFeatureRequestsIndexRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/courses/$courseId/edit-avatars': typeof AppCoursesCourseIdEditAvatarsRoute
  '/courses/$courseId/edit-info': typeof AppCoursesCourseIdEditInfoRoute
  '/courses/$courseId/edit-lessons': typeof AppCoursesCourseIdEditLessonsRoute
  '/courses/$courseId/manage-access': typeof AppCoursesCourseIdManageAccessRoute
  '/courses/$courseId/see-analytics': typeof AppCoursesCourseIdSeeAnalyticsRoute
  '/create/ebook/flow': typeof AppCreateEbookFlowRoute
  '/create/linkedin/flow': typeof AppCreateLinkedinFlowRoute
  '/admin/courses/$courseId/manage-access': typeof AdminCoursesCourseIdManageAccessRoute
  '/admin/courses/$courseId/see-analytics': typeof AdminCoursesCourseIdSeeAnalyticsRoute
  '/admin/courses/$courseId/view-avatars': typeof AdminCoursesCourseIdViewAvatarsRoute
  '/admin/courses/$courseId/view-info': typeof AdminCoursesCourseIdViewInfoRoute
  '/admin/courses/$courseId/view-lessons': typeof AdminCoursesCourseIdViewLessonsRoute
  '/courses/$courseId': typeof AppCoursesCourseIdIndexRoute
  '/create/ebook': typeof AppCreateEbookIndexRoute
  '/create/linkedin': typeof AppCreateLinkedinIndexRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/confirm-email': typeof AuthConfirmEmailRoute
  '/login': typeof AuthLoginRoute
  '/signup': typeof AuthSignupRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/avatars/create': typeof AppAvatarsCreateRoute
  '/premium/plans': typeof AppPremiumPlansRoute
  '/settings/account-settings': typeof AppSettingsAccountSettingsRoute
  '/settings/subscription': typeof AppSettingsSubscriptionRoute
  '/avatars': typeof AppAvatarsIndexRoute
  '/chat': typeof AppChatIndexRoute
  '/courses': typeof AppCoursesIndexRoute
  '/create': typeof AppCreateIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/feedback': typeof AppFeedbackIndexRoute
  '/marketing-kit': typeof AppMarketingKitIndexRoute
  '/premium': typeof AppPremiumIndexRoute
  '/admin/courses': typeof AdminCoursesIndexRoute
  '/admin/feature-requests': typeof AdminFeatureRequestsIndexRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/courses/$courseId/edit-avatars': typeof AppCoursesCourseIdEditAvatarsRoute
  '/courses/$courseId/edit-info': typeof AppCoursesCourseIdEditInfoRoute
  '/courses/$courseId/edit-lessons': typeof AppCoursesCourseIdEditLessonsRoute
  '/courses/$courseId/manage-access': typeof AppCoursesCourseIdManageAccessRoute
  '/courses/$courseId/see-analytics': typeof AppCoursesCourseIdSeeAnalyticsRoute
  '/create/ebook/flow': typeof AppCreateEbookFlowRoute
  '/create/linkedin/flow': typeof AppCreateLinkedinFlowRoute
  '/admin/courses/$courseId/manage-access': typeof AdminCoursesCourseIdManageAccessRoute
  '/admin/courses/$courseId/see-analytics': typeof AdminCoursesCourseIdSeeAnalyticsRoute
  '/admin/courses/$courseId/view-avatars': typeof AdminCoursesCourseIdViewAvatarsRoute
  '/admin/courses/$courseId/view-info': typeof AdminCoursesCourseIdViewInfoRoute
  '/admin/courses/$courseId/view-lessons': typeof AdminCoursesCourseIdViewLessonsRoute
  '/courses/$courseId': typeof AppCoursesCourseIdIndexRoute
  '/create/ebook': typeof AppCreateEbookIndexRoute
  '/create/linkedin': typeof AppCreateLinkedinIndexRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/admin': typeof AdminRouteRouteWithChildren
  '/_app/premium': typeof AppPremiumRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_auth/confirm-email': typeof AuthConfirmEmailRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/_app/avatars/create': typeof AppAvatarsCreateRoute
  '/_app/premium/plans': typeof AppPremiumPlansRoute
  '/_app/settings/account-settings': typeof AppSettingsAccountSettingsRoute
  '/_app/settings/subscription': typeof AppSettingsSubscriptionRoute
  '/_app/avatars/': typeof AppAvatarsIndexRoute
  '/_app/chat/': typeof AppChatIndexRoute
  '/_app/courses/': typeof AppCoursesIndexRoute
  '/_app/create/': typeof AppCreateIndexRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/feedback/': typeof AppFeedbackIndexRoute
  '/_app/marketing-kit/': typeof AppMarketingKitIndexRoute
  '/_app/premium/': typeof AppPremiumIndexRoute
  '/admin/courses/': typeof AdminCoursesIndexRoute
  '/admin/feature-requests/': typeof AdminFeatureRequestsIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/_app/courses/$courseId/edit-avatars': typeof AppCoursesCourseIdEditAvatarsRoute
  '/_app/courses/$courseId/edit-info': typeof AppCoursesCourseIdEditInfoRoute
  '/_app/courses/$courseId/edit-lessons': typeof AppCoursesCourseIdEditLessonsRoute
  '/_app/courses/$courseId/manage-access': typeof AppCoursesCourseIdManageAccessRoute
  '/_app/courses/$courseId/see-analytics': typeof AppCoursesCourseIdSeeAnalyticsRoute
  '/_app/create/ebook/flow': typeof AppCreateEbookFlowRoute
  '/_app/create/linkedin/flow': typeof AppCreateLinkedinFlowRoute
  '/admin/courses/$courseId/manage-access': typeof AdminCoursesCourseIdManageAccessRoute
  '/admin/courses/$courseId/see-analytics': typeof AdminCoursesCourseIdSeeAnalyticsRoute
  '/admin/courses/$courseId/view-avatars': typeof AdminCoursesCourseIdViewAvatarsRoute
  '/admin/courses/$courseId/view-info': typeof AdminCoursesCourseIdViewInfoRoute
  '/admin/courses/$courseId/view-lessons': typeof AdminCoursesCourseIdViewLessonsRoute
  '/_app/courses/$courseId/': typeof AppCoursesCourseIdIndexRoute
  '/_app/create/ebook/': typeof AppCreateEbookIndexRoute
  '/_app/create/linkedin/': typeof AppCreateLinkedinIndexRoute
  '/admin/courses/$courseId/': typeof AdminCoursesCourseIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/premium'
    | '/settings'
    | '/confirm-email'
    | '/login'
    | '/signup'
    | '/admin/dashboard'
    | '/avatars/create'
    | '/premium/plans'
    | '/settings/account-settings'
    | '/settings/subscription'
    | '/avatars'
    | '/chat'
    | '/courses'
    | '/create'
    | '/dashboard'
    | '/feedback'
    | '/marketing-kit'
    | '/premium/'
    | '/admin/courses'
    | '/admin/feature-requests'
    | '/admin/settings'
    | '/courses/$courseId/edit-avatars'
    | '/courses/$courseId/edit-info'
    | '/courses/$courseId/edit-lessons'
    | '/courses/$courseId/manage-access'
    | '/courses/$courseId/see-analytics'
    | '/create/ebook/flow'
    | '/create/linkedin/flow'
    | '/admin/courses/$courseId/manage-access'
    | '/admin/courses/$courseId/see-analytics'
    | '/admin/courses/$courseId/view-avatars'
    | '/admin/courses/$courseId/view-info'
    | '/admin/courses/$courseId/view-lessons'
    | '/courses/$courseId'
    | '/create/ebook'
    | '/create/linkedin'
    | '/admin/courses/$courseId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/settings'
    | '/confirm-email'
    | '/login'
    | '/signup'
    | '/admin/dashboard'
    | '/avatars/create'
    | '/premium/plans'
    | '/settings/account-settings'
    | '/settings/subscription'
    | '/avatars'
    | '/chat'
    | '/courses'
    | '/create'
    | '/dashboard'
    | '/feedback'
    | '/marketing-kit'
    | '/premium'
    | '/admin/courses'
    | '/admin/feature-requests'
    | '/admin/settings'
    | '/courses/$courseId/edit-avatars'
    | '/courses/$courseId/edit-info'
    | '/courses/$courseId/edit-lessons'
    | '/courses/$courseId/manage-access'
    | '/courses/$courseId/see-analytics'
    | '/create/ebook/flow'
    | '/create/linkedin/flow'
    | '/admin/courses/$courseId/manage-access'
    | '/admin/courses/$courseId/see-analytics'
    | '/admin/courses/$courseId/view-avatars'
    | '/admin/courses/$courseId/view-info'
    | '/admin/courses/$courseId/view-lessons'
    | '/courses/$courseId'
    | '/create/ebook'
    | '/create/linkedin'
    | '/admin/courses/$courseId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/admin'
    | '/_app/premium'
    | '/_app/settings'
    | '/_auth/confirm-email'
    | '/_auth/login'
    | '/_auth/signup'
    | '/admin/dashboard'
    | '/_app/avatars/create'
    | '/_app/premium/plans'
    | '/_app/settings/account-settings'
    | '/_app/settings/subscription'
    | '/_app/avatars/'
    | '/_app/chat/'
    | '/_app/courses/'
    | '/_app/create/'
    | '/_app/dashboard/'
    | '/_app/feedback/'
    | '/_app/marketing-kit/'
    | '/_app/premium/'
    | '/admin/courses/'
    | '/admin/feature-requests/'
    | '/admin/settings/'
    | '/_app/courses/$courseId/edit-avatars'
    | '/_app/courses/$courseId/edit-info'
    | '/_app/courses/$courseId/edit-lessons'
    | '/_app/courses/$courseId/manage-access'
    | '/_app/courses/$courseId/see-analytics'
    | '/_app/create/ebook/flow'
    | '/_app/create/linkedin/flow'
    | '/admin/courses/$courseId/manage-access'
    | '/admin/courses/$courseId/see-analytics'
    | '/admin/courses/$courseId/view-avatars'
    | '/admin/courses/$courseId/view-info'
    | '/admin/courses/$courseId/view-lessons'
    | '/_app/courses/$courseId/'
    | '/_app/create/ebook/'
    | '/_app/create/linkedin/'
    | '/admin/courses/$courseId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/confirm-email': {
      id: '/_auth/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof AuthConfirmEmailRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/premium': {
      id: '/_app/premium'
      path: '/premium'
      fullPath: '/premium'
      preLoaderRoute: typeof AppPremiumRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/settings/': {
      id: '/admin/settings/'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/feature-requests/': {
      id: '/admin/feature-requests/'
      path: '/feature-requests'
      fullPath: '/admin/feature-requests'
      preLoaderRoute: typeof AdminFeatureRequestsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/courses/': {
      id: '/admin/courses/'
      path: '/courses'
      fullPath: '/admin/courses'
      preLoaderRoute: typeof AdminCoursesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/premium/': {
      id: '/_app/premium/'
      path: '/'
      fullPath: '/premium/'
      preLoaderRoute: typeof AppPremiumIndexRouteImport
      parentRoute: typeof AppPremiumRouteRoute
    }
    '/_app/marketing-kit/': {
      id: '/_app/marketing-kit/'
      path: '/marketing-kit'
      fullPath: '/marketing-kit'
      preLoaderRoute: typeof AppMarketingKitIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/feedback/': {
      id: '/_app/feedback/'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AppFeedbackIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/create/': {
      id: '/_app/create/'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof AppCreateIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/courses/': {
      id: '/_app/courses/'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof AppCoursesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/chat/': {
      id: '/_app/chat/'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AppChatIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/avatars/': {
      id: '/_app/avatars/'
      path: '/avatars'
      fullPath: '/avatars'
      preLoaderRoute: typeof AppAvatarsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/subscription': {
      id: '/_app/settings/subscription'
      path: '/subscription'
      fullPath: '/settings/subscription'
      preLoaderRoute: typeof AppSettingsSubscriptionRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/account-settings': {
      id: '/_app/settings/account-settings'
      path: '/account-settings'
      fullPath: '/settings/account-settings'
      preLoaderRoute: typeof AppSettingsAccountSettingsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/premium/plans': {
      id: '/_app/premium/plans'
      path: '/plans'
      fullPath: '/premium/plans'
      preLoaderRoute: typeof AppPremiumPlansRouteImport
      parentRoute: typeof AppPremiumRouteRoute
    }
    '/_app/avatars/create': {
      id: '/_app/avatars/create'
      path: '/avatars/create'
      fullPath: '/avatars/create'
      preLoaderRoute: typeof AppAvatarsCreateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/courses/$courseId/': {
      id: '/admin/courses/$courseId/'
      path: '/courses/$courseId'
      fullPath: '/admin/courses/$courseId'
      preLoaderRoute: typeof AdminCoursesCourseIdIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/create/linkedin/': {
      id: '/_app/create/linkedin/'
      path: '/create/linkedin'
      fullPath: '/create/linkedin'
      preLoaderRoute: typeof AppCreateLinkedinIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/create/ebook/': {
      id: '/_app/create/ebook/'
      path: '/create/ebook'
      fullPath: '/create/ebook'
      preLoaderRoute: typeof AppCreateEbookIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/courses/$courseId/': {
      id: '/_app/courses/$courseId/'
      path: '/courses/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof AppCoursesCourseIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/courses/$courseId/view-lessons': {
      id: '/admin/courses/$courseId/view-lessons'
      path: '/courses/$courseId/view-lessons'
      fullPath: '/admin/courses/$courseId/view-lessons'
      preLoaderRoute: typeof AdminCoursesCourseIdViewLessonsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/courses/$courseId/view-info': {
      id: '/admin/courses/$courseId/view-info'
      path: '/courses/$courseId/view-info'
      fullPath: '/admin/courses/$courseId/view-info'
      preLoaderRoute: typeof AdminCoursesCourseIdViewInfoRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/courses/$courseId/view-avatars': {
      id: '/admin/courses/$courseId/view-avatars'
      path: '/courses/$courseId/view-avatars'
      fullPath: '/admin/courses/$courseId/view-avatars'
      preLoaderRoute: typeof AdminCoursesCourseIdViewAvatarsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/courses/$courseId/see-analytics': {
      id: '/admin/courses/$courseId/see-analytics'
      path: '/courses/$courseId/see-analytics'
      fullPath: '/admin/courses/$courseId/see-analytics'
      preLoaderRoute: typeof AdminCoursesCourseIdSeeAnalyticsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/courses/$courseId/manage-access': {
      id: '/admin/courses/$courseId/manage-access'
      path: '/courses/$courseId/manage-access'
      fullPath: '/admin/courses/$courseId/manage-access'
      preLoaderRoute: typeof AdminCoursesCourseIdManageAccessRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/create/linkedin/flow': {
      id: '/_app/create/linkedin/flow'
      path: '/create/linkedin/flow'
      fullPath: '/create/linkedin/flow'
      preLoaderRoute: typeof AppCreateLinkedinFlowRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/create/ebook/flow': {
      id: '/_app/create/ebook/flow'
      path: '/create/ebook/flow'
      fullPath: '/create/ebook/flow'
      preLoaderRoute: typeof AppCreateEbookFlowRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/courses/$courseId/see-analytics': {
      id: '/_app/courses/$courseId/see-analytics'
      path: '/courses/$courseId/see-analytics'
      fullPath: '/courses/$courseId/see-analytics'
      preLoaderRoute: typeof AppCoursesCourseIdSeeAnalyticsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/courses/$courseId/manage-access': {
      id: '/_app/courses/$courseId/manage-access'
      path: '/courses/$courseId/manage-access'
      fullPath: '/courses/$courseId/manage-access'
      preLoaderRoute: typeof AppCoursesCourseIdManageAccessRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/courses/$courseId/edit-lessons': {
      id: '/_app/courses/$courseId/edit-lessons'
      path: '/courses/$courseId/edit-lessons'
      fullPath: '/courses/$courseId/edit-lessons'
      preLoaderRoute: typeof AppCoursesCourseIdEditLessonsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/courses/$courseId/edit-info': {
      id: '/_app/courses/$courseId/edit-info'
      path: '/courses/$courseId/edit-info'
      fullPath: '/courses/$courseId/edit-info'
      preLoaderRoute: typeof AppCoursesCourseIdEditInfoRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/courses/$courseId/edit-avatars': {
      id: '/_app/courses/$courseId/edit-avatars'
      path: '/courses/$courseId/edit-avatars'
      fullPath: '/courses/$courseId/edit-avatars'
      preLoaderRoute: typeof AppCoursesCourseIdEditAvatarsRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppPremiumRouteRouteChildren {
  AppPremiumPlansRoute: typeof AppPremiumPlansRoute
  AppPremiumIndexRoute: typeof AppPremiumIndexRoute
}

const AppPremiumRouteRouteChildren: AppPremiumRouteRouteChildren = {
  AppPremiumPlansRoute: AppPremiumPlansRoute,
  AppPremiumIndexRoute: AppPremiumIndexRoute,
}

const AppPremiumRouteRouteWithChildren = AppPremiumRouteRoute._addFileChildren(
  AppPremiumRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsAccountSettingsRoute: typeof AppSettingsAccountSettingsRoute
  AppSettingsSubscriptionRoute: typeof AppSettingsSubscriptionRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsAccountSettingsRoute: AppSettingsAccountSettingsRoute,
  AppSettingsSubscriptionRoute: AppSettingsSubscriptionRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppPremiumRouteRoute: typeof AppPremiumRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppAvatarsCreateRoute: typeof AppAvatarsCreateRoute
  AppAvatarsIndexRoute: typeof AppAvatarsIndexRoute
  AppChatIndexRoute: typeof AppChatIndexRoute
  AppCoursesIndexRoute: typeof AppCoursesIndexRoute
  AppCreateIndexRoute: typeof AppCreateIndexRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppFeedbackIndexRoute: typeof AppFeedbackIndexRoute
  AppMarketingKitIndexRoute: typeof AppMarketingKitIndexRoute
  AppCoursesCourseIdEditAvatarsRoute: typeof AppCoursesCourseIdEditAvatarsRoute
  AppCoursesCourseIdEditInfoRoute: typeof AppCoursesCourseIdEditInfoRoute
  AppCoursesCourseIdEditLessonsRoute: typeof AppCoursesCourseIdEditLessonsRoute
  AppCoursesCourseIdManageAccessRoute: typeof AppCoursesCourseIdManageAccessRoute
  AppCoursesCourseIdSeeAnalyticsRoute: typeof AppCoursesCourseIdSeeAnalyticsRoute
  AppCreateEbookFlowRoute: typeof AppCreateEbookFlowRoute
  AppCreateLinkedinFlowRoute: typeof AppCreateLinkedinFlowRoute
  AppCoursesCourseIdIndexRoute: typeof AppCoursesCourseIdIndexRoute
  AppCreateEbookIndexRoute: typeof AppCreateEbookIndexRoute
  AppCreateLinkedinIndexRoute: typeof AppCreateLinkedinIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppPremiumRouteRoute: AppPremiumRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppAvatarsCreateRoute: AppAvatarsCreateRoute,
  AppAvatarsIndexRoute: AppAvatarsIndexRoute,
  AppChatIndexRoute: AppChatIndexRoute,
  AppCoursesIndexRoute: AppCoursesIndexRoute,
  AppCreateIndexRoute: AppCreateIndexRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppFeedbackIndexRoute: AppFeedbackIndexRoute,
  AppMarketingKitIndexRoute: AppMarketingKitIndexRoute,
  AppCoursesCourseIdEditAvatarsRoute: AppCoursesCourseIdEditAvatarsRoute,
  AppCoursesCourseIdEditInfoRoute: AppCoursesCourseIdEditInfoRoute,
  AppCoursesCourseIdEditLessonsRoute: AppCoursesCourseIdEditLessonsRoute,
  AppCoursesCourseIdManageAccessRoute: AppCoursesCourseIdManageAccessRoute,
  AppCoursesCourseIdSeeAnalyticsRoute: AppCoursesCourseIdSeeAnalyticsRoute,
  AppCreateEbookFlowRoute: AppCreateEbookFlowRoute,
  AppCreateLinkedinFlowRoute: AppCreateLinkedinFlowRoute,
  AppCoursesCourseIdIndexRoute: AppCoursesCourseIdIndexRoute,
  AppCreateEbookIndexRoute: AppCreateEbookIndexRoute,
  AppCreateLinkedinIndexRoute: AppCreateLinkedinIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthConfirmEmailRoute: typeof AuthConfirmEmailRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthConfirmEmailRoute: AuthConfirmEmailRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AdminRouteRouteChildren {
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminCoursesIndexRoute: typeof AdminCoursesIndexRoute
  AdminFeatureRequestsIndexRoute: typeof AdminFeatureRequestsIndexRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
  AdminCoursesCourseIdManageAccessRoute: typeof AdminCoursesCourseIdManageAccessRoute
  AdminCoursesCourseIdSeeAnalyticsRoute: typeof AdminCoursesCourseIdSeeAnalyticsRoute
  AdminCoursesCourseIdViewAvatarsRoute: typeof AdminCoursesCourseIdViewAvatarsRoute
  AdminCoursesCourseIdViewInfoRoute: typeof AdminCoursesCourseIdViewInfoRoute
  AdminCoursesCourseIdViewLessonsRoute: typeof AdminCoursesCourseIdViewLessonsRoute
  AdminCoursesCourseIdIndexRoute: typeof AdminCoursesCourseIdIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminDashboardRoute: AdminDashboardRoute,
  AdminCoursesIndexRoute: AdminCoursesIndexRoute,
  AdminFeatureRequestsIndexRoute: AdminFeatureRequestsIndexRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
  AdminCoursesCourseIdManageAccessRoute: AdminCoursesCourseIdManageAccessRoute,
  AdminCoursesCourseIdSeeAnalyticsRoute: AdminCoursesCourseIdSeeAnalyticsRoute,
  AdminCoursesCourseIdViewAvatarsRoute: AdminCoursesCourseIdViewAvatarsRoute,
  AdminCoursesCourseIdViewInfoRoute: AdminCoursesCourseIdViewInfoRoute,
  AdminCoursesCourseIdViewLessonsRoute: AdminCoursesCourseIdViewLessonsRoute,
  AdminCoursesCourseIdIndexRoute: AdminCoursesCourseIdIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
